<template>
    <div class="pt-8">
        <h2 class="text-base font-medium text-gray-700 mb-1 text-center">Assemblies</h2>
        <div class="bg-gray-50 border border-gray-200 rounded-xl py-4 px-2" :key="renderKey">
            <div v-for="(item,index) in collectedItems" :key="`item`+index" @click="edit(item)"
                 class="text-gray-600 text-sm w-full truncate flex relative bg-transparent hover:bg-white rounded-xl border border-gray-50 hover:border-gray-200 cursor-pointer"
                 @mouseover="highlight(item.items[0])" @mouseleave="unhighlight"
                 v-if="item.quantity > 1 && (item.items[0].materials.length || item.items[0].labour.length || item.items[0].fixedCosts.length)"
            >
                <estimate-assembly-pinger :item="item.items[0]" :estimate="estimate"
                                          :pinging="isPinging(item.items[0])"
                                          class="top-1.5 left-1"></estimate-assembly-pinger>
                <div
                    class="py-0.5 pl-6 truncate flex-1"
                    v-text="estimate.getTitle(item.items[0])"
                ></div>
                <div class="flex-0 pr-2 w-4">{{ item.quantity }}</div>
            </div>
        </div>
    </div>
</template>

<script>

import {Estimate} from "@models";
import EstimateAssemblyPinger from "./EstimateAssemblyPinger.vue";

export default {
    components: {EstimateAssemblyPinger},
    props: {
        store: Object,
        estimate: Estimate,
        pinging: null,
    },
    watch: {
        estimate: {
            handler(newValue, oldValue) {
                this.collectedItems = [...this.estimate.collectedItems.items].map(([name, value]) => ({
                    key: name,
                    item: value.item,
                    items: value.items,
                    quantity: value.quantity,
                    hasBundle: value.hasBundle,
                })).filter((i) => !i.hasBundle).sort((a, b) => a.item.description.localeCompare(b.item.description))
            },
            deep: true,
        },
        "estimate.collectionBuildUUID": {
            handler(newValue, oldValue) {
                this.renderKey = this.renderKey + 1
            },
            deep: true,
        },
    },
    data() {
        return {
            renderKey: 0,
            collectedItems: [...this.estimate.collectedItems.items].map(([name, value]) => ({
                key: name,
                item: value.item,
                items: value.items,
                quantity: value.quantity,
                hasBundle: value.hasBundle,
            })).filter((i) => !i.hasBundle && i.item.description).sort((a, b) => a.item.description.localeCompare(b.item.description))
        }
    },
    methods: {
        isPinging(i) {
            return this.pinging === Estimate.itemAsKey(i)
        },
        edit: function (item) {
            this.$modals.open('estimate-task-item-build', {
                item: item.items[0],
                editAsAssembly: true,
                estimate: this.estimate,
                store: this.store
            })
        },
        highlight(i) {
            this.$emit('ping', Estimate.itemAsKey(i))
        },
        unhighlight() {
            this.$emit('ping', null)
        },
    },
}
</script>
